import { Container } from '../../vendor/pixi.min.mjs';

/**
 * Abstract base for all scenes.
 * Each scene owns a Container that gets added/removed from the stage automatically.
 */
export class BaseScene {
    /** @type {Container} Root display container for this scene */
    container = new Container();

    /** @type {import('../core/Game.js').Game} */
    game = null;

    /**
     * Called once when the scene becomes active.
     * Override in subclasses to set up visuals and state.
     * @param {import('../core/Game.js').Game} game
     */
    init(game) {
        this.game = game;
    }

    /**
     * Called every frame while the scene is active.
     * @param {number} delta — frame delta (1 = normal speed at 60 FPS)
     */
    update(delta) {
        // override
    }

    /**
     * Called when leaving this scene. Clean up listeners, tweens, etc.
     */
    destroy() {
        this.container.removeChildren();
    }
}
